import { Link } from "react-router-dom";
import { Users, Sparkles, ShieldCheck } from "lucide-react";
import FollowButton from "./FollowButton";
import { sfx } from "@/lib/sounds";

export default function UserCard({ user, initialFollowing = false, compact = false }) {
  return (
    <div className="rounded-xl glass p-4 hover-lift" data-testid={`user-card-${user.id}`}>
      <div className="flex items-start gap-3">
        <Link to={`/users/${user.id}`} onClick={() => sfx.click()} className="shrink-0">
          <img
            src={user.avatar || `https://mc-heads.net/avatar/${user.mc_username || "MHF_Steve"}/64`}
            alt=""
            className="w-12 h-12 rounded-lg border border-white/10 object-cover"
          />
        </Link>
        <div className="flex-1 min-w-0">
          <Link
            to={`/users/${user.id}`}
            onClick={() => sfx.click()}
            className="font-semibold hover:text-[#FFBF00] line-clamp-1"
          >
            {user.name}
          </Link>
          <div className="flex items-center gap-1.5 mt-0.5 text-[10px] uppercase tracking-widest">
            {user.is_creator && (
              <span className="inline-flex items-center gap-1 text-[#FFBF00]">
                <Sparkles size={9} /> Creator
              </span>
            )}
            {user.creator_level > 0 && (
              <span className="text-white/40 font-mono">Lvl {user.creator_level}</span>
            )}
          </div>
          {user.mc_username && (
            <div className="text-[11px] font-mono text-[#FFBF00]/70 mt-0.5 line-clamp-1">
              {user.mc_username}
            </div>
          )}
          {!compact && user.bio && (
            <div className="text-[11px] text-white/50 mt-1 line-clamp-2">{user.bio}</div>
          )}
          <div className="flex items-center gap-3 mt-2 text-[10px] text-white/50">
            <span className="inline-flex items-center gap-1">
              <Users size={10} /> {(user.followers_count || 0).toLocaleString("en-IN")}
            </span>
          </div>
        </div>
        <FollowButton userId={user.id} initialFollowing={initialFollowing} size="sm" />
      </div>
    </div>
  );
}
